<template>
  <div class="wrapper" v-loading="ifLoading">
    <div class="contentContainer">
      <div class="totalDescribe">
        <div class="describe">
          <i class="el-icon-user-solid" style=""></i>
          <div class="name">
            <strong>{{ staffData.groupName }}</strong>
            <br />
            {{ staffData.roleName }}
          </div>
        </div>
        <div class="actSide">
          <el-button size="small" @click="editStaff">编辑员工</el-button>
          <el-button size="small">删除员工</el-button>
        </div>
      </div>
      <el-tabs v-model="activeName" type="card" @tab-click="getData">
        <el-tab-pane label="登录日志" name="loginLog">
          <el-table :data="loginLog" border style="width: 100%">
            <el-table-column
              prop="createTime"
              label="登录时间"
              min-width="100"
            ></el-table-column
            ><el-table-column
              prop="terminalType"
              label="终端类型"
              min-width="100"
            ></el-table-column
            ><el-table-column
              prop="browserVersion"
              label="浏览器/终端版本"
              min-width="100"
            ></el-table-column
            ><el-table-column
              prop="operateSystem"
              label="操作系统"
              min-width="100"
            ></el-table-column
            ><el-table-column
              prop="equipmentName"
              label="设备名称"
              min-width="100"
            ></el-table-column
            ><el-table-column
              prop="ip"
              label="登录IP"
              min-width="100"
            ></el-table-column
            ><el-table-column
              prop="address"
              label="地址"
              min-width="100"
            ></el-table-column
          ></el-table>
        </el-tab-pane>
        <el-tab-pane label="操作记录" name="actLog">
          <el-table :data="actLog" border style="width: 100%">
            <el-table-column
              prop="module"
              label="操作"
              min-width="100"
            ></el-table-column
            ><el-table-column
              prop="operateTime"
              label="时间"
              min-width="100"
            ></el-table-column
            ><el-table-column
              prop="userName"
              label="操作人"
              min-width="100"
            ></el-table-column
            ><el-table-column
              prop="remark"
              label="备注信息"
              min-width="100"
            ></el-table-column
          ></el-table>
        </el-tab-pane>
      </el-tabs>
    </div>
    <el-dialog
      title="用户编辑"
      :visible.sync="staffDataEdit.ifShow"
      append-to-body
      top="2vh"
      width="50%"
    >
      <staff-edit :staffData="staffDataEdit" @eventUp="staffEvent"></staff-edit
    ></el-dialog>
  </div>
</template>

<script>
import { singleLoginLog, singleActLog } from "@/api/index";
import staffEdit from "./staffEdit.vue";

export default {
  data() {
    return {
      activeName: "loginLog",
      powerTree: [],
      staffData: {},
      staffDataEdit: {
        ifShow: false,
        userName: "",
        account: "",
        password: "",
        groupId: "",
        roleId: "",
        sex: 0,
        birthdayDate: null,
        emailAddress: "",
        mobile: "",
        weChatAccount: "",
        landline: "",
        jobNumber: "",
        hometown: "",
        graduatedSchool: "",
        graduatedDate: null,
        education: "",
        major: "",
        remark: "",
        id: 0,
      },
      loginLog: [],
      actLog: [],
      ifLoading: false,
    };
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
  created() {},
  mounted() {
    this.staffData = this.$route.query;
    this.getData();
  },
  methods: {
    editStaff(item) {
      Object.assign(this.staffDataEdit, this.staffData);

      this.staffDataEdit.ifShow = true;
    },
    staffEvent(options) {
      switch (options.type) {
        case "success":
          this.$message.success(options.value);
          this.getData();
          this.staffDataEdit.ifShow = false;
          console.log(options);

          break;

        default:
          break;
      }
    },
    getData() {
      this.ifLoading = true;
      switch (this.activeName) {
        case "loginLog":
          singleLoginLog({ userId: this.staffData.id }).then((data) => {
            this.loginLog = data.data.rows;
            this.ifLoading = false;
          });
          break;
        case "actLog":
          singleActLog({ userId: this.staffData.id }).then((data) => {
            this.actLog = data.data.rows;
            this.ifLoading = false;
          });
          break;
        default:
          break;
      }
    },
  },
  components: { staffEdit },
};

function calcCheckNodes(total, current, idx, arr) {
  if (current.checked) {
    total.push(current.id);
  }
  if (current.children && current.children.length > 0) {
    current.children.reduce(calcCheckNodes, total);
  }
  return total;
}
</script>

<style scoped lang="less">
.wrapper {
  background: #fff;
  padding: 30px 0;
  min-height: 800px;
  .contentContainer {
    border: 1px solid #ccc;
    width: 70%;
    margin: 30px auto;
    padding: 20px;
    .treeContainer {
      padding: 20px 15%;
    }
    .totalDescribe {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .describe {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        .el-icon-user-solid {
          font-size: 36px;
          color: #fff;
          padding: 10px;
          background: orange;
          border-radius: 50%;
          margin-right: 20px;
        }
        .name {
          font-size: 14px;
          strong {
            font-size: 18px;
          }
        }
      }
      .actSide {
      }
    }
  }
}
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
</style>
